// ! This file was auto-generated from the weaver OpenAPI schema. Do not override this file.
export const Tags = {
    Comment: "Comment"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
